export default [
  {
    path: "/approve/:id",
    name: "approve",
    component: () => import("@/views/approveCloud/approveCloud.vue"),
    meta: {
      title: "审批中心",
    },
  },
];
